import React, { useState, useEffect } from 'react';
import {useAuth} from "../../helpers/AuthContext";
import Table from "../Table";

function ProductMultiselect({values = [], onChange}) {
    const { API_URL, fetch } = useAuth();
    const [products, setProducts] = useState([]);

    const fetchProducts = async () => {
        try {
            const response = await fetch(`${API_URL}/v1/seller/products`);
            if (response.ok) {
                const data = await response.json();
                setProducts(data.data);
            } else {
                console.error('Failed to fetch products');
            }
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    };

    const handleSelect = (e) => {
        const productId = e.target.value;
        const isSelected = e.target.checked;
        setProducts(prevProducts =>
            prevProducts.map(product =>
                product.id === productId ? { ...product, selected: isSelected } : product
            )
        );

        const updatedValues = isSelected
            ? [...values, productId]
            : values.filter(id => id !== productId);

        console.log("Updated selected product IDs:", updatedValues);

        if (onChange) {
            onChange(updatedValues);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    return (
        <Table
            data={products}
            columns={[
                {
                    key: 'select',
                    sortable: false,
                    header: <input
                        type="checkbox"
                        onChange={(e) => {
                            const isChecked = e.target.checked;
                            const updatedValues = isChecked
                                ? [...products.map(p => p.id.toString())]
                                : [];
                            if (onChange) {
                                onChange(updatedValues);
                            }
                        }}
                        checked={values.length === products.length && products.length > 0}
                    />,
                    render: (value, row) => {

                        const isChecked = values.includes(row.id.toString());

                        return (
                            <input
                                type="checkbox"
                                name={`select-${row.id}`}
                                value={row.id}
                                checked={isChecked}
                                onChange={handleSelect}
                            />
                        )

                    }
                },
                {
                    key: 'name',
                    header: 'Product'
                }
            ]}
        />
    )

}

export default ProductMultiselect;